import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { api, formatINR } from "@/lib/api";

const CheckoutSuccess = () => {
  const [sp] = useSearchParams();
  const order_id = sp.get("order_id");
  const session_id = sp.get("session_id");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    (async () => {
      if (session_id && session_id !== "{CHECKOUT_SESSION_ID}") {
        try { await api.get(`/payments/stripe/session`, { params: { session_id } }); } catch {}
      }
      if (order_id) {
        try {
          const { data } = await api.get(`/orders/${order_id}`);
          setOrder(data);
        } catch {}
      }
    })();
  }, [order_id, session_id]);

  return (
    <div className="rieave-container py-24 text-center" data-testid="checkout-success-page">
      <div className="mx-auto w-16 h-16 rounded-full bg-blush flex items-center justify-center mb-6">
        <CheckCircle2 className="text-rose" />
      </div>
      <p className="eyebrow mb-2">Order placed</p>
      <h1 className="font-hero text-5xl mb-4">Thank you, <span className="serif-italic text-rose">beautifully done.</span></h1>
      {order && (
        <>
          <p className="text-mauve mb-2">Order <span className="text-charcoal font-label tracking-[0.22em] uppercase">{order.order_number}</span></p>
          <p className="text-mauve mb-8">Total {formatINR(order.total)} · {order.payment_method.toUpperCase()}</p>
        </>
      )}
      <p className="text-mauve mb-8 max-w-md mx-auto">We've received your order and sent a confirmation to your inbox. Your pieces will be wrapped with care and dispatched shortly.</p>
      <Link to="/shop" className="btn-primary">Continue shopping</Link>
    </div>
  );
};

export default CheckoutSuccess;
